// @ts-ignore
import {version} from '../../package.json';

export const environment = {
    production: true,
    title: 'Suite Master',
    baseUrl: 'https://api.suitemaster.eolo.it/',
    assetsUrl: 'https://ewr1.vultrobjects.com/mgroup/static/',
    baseAwsUrl: 'https://ewr1.vultrobjects.com',
    apiUrl: 'https://api.suitemaster.eolo.it/v1',
    dashboardUrl: 'https://api.suitemaster.eolo.it/dashboard',
    operatorUrl: 'https://api.suitemaster.eolo.it/operator',
    language: 'it',
    startDate: '2022-01',
    whatsAppUrl: '',
    telegramUrl: '',
    company: {
        url: 'https://eolo.it',
        name: 'Eolo'
    },
    entraClientId: 'f75e729c-28e9-47c2-bfb3-688f6385800a',
    entraTenantId: '3eb573ab-f148-4769-95fd-b69696295c69',
    version
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
